export default "__VITE_ASSET__D3gcikw6__"